import { QueryClient } from '@tanstack/react-query';

/**
 * staleTime de 5 minutos: listas de suporte (temas, filiais, tipos de loja) mudam raramente,
 * então revalidar em toda montagem de componente é desnecessário para o volume atual.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
});
